import type { TextareaAutosizeProps } from '@mui/material';
import { TextareaAutosize } from '@mui/material';
import { screenMdMin } from '../styles';

const blue = {
  100: '#DAECFF',
  200: '#b6daff',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

interface TextareaProps extends TextareaAutosizeProps {
  spaceleft?: boolean;
}

export function Textarea(props: TextareaProps) {
  const { spaceleft, style, onBlur: externalOnBlur, onFocus: externalOnFocus, ...rest } = props;

  return (
    <TextareaAutosize
      {...rest}
      style={{
        width: '100%',
        fontFamily: "'IBM Plex Sans', sans-serif",
        padding: '8px 12px',
        borderRadius: '8px',
        color: grey[900],
        background: '#fff',
        border: `1px solid ${grey[200]}`,
        boxShadow: `0px 2px 2px ${grey[50]}`,
        ...(spaceleft && {
          [`@media ${screenMdMin}`]: {
            marginLeft: 'var(--spacing-md)',
          },
        }),
        ...style,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = blue[400];
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = grey[200];
      }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = blue[400];
        e.currentTarget.style.boxShadow = `0 0 0 3px ${blue[200]}`;
        e.currentTarget.style.outline = '0';
        externalOnFocus?.(e);
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = grey[200];
        e.currentTarget.style.boxShadow = `0px 2px 2px ${grey[50]}`;
        externalOnBlur?.(e);
      }}
    />
  );
}

function TextArea() {
  return <div>TextArea</div>;
}

export default TextArea;
